import { CountryCode } from '../../types';
import { CountryFlagProp } from './country-flag-properties';

export function getCountryFlag(country?: CountryCode): string {
  if (!country) return '🏴‍☠️';

  return CountryFlagProp[country];
}
